export default __webpack_public_path__ + "static/media/ArchivesTimes_Vol3Issue3.ec6eabd0.png";